export default __webpack_public_path__ + "static/tellowteam-031e493b8cf3885e318492fdb30629c999fbf1c178bcbd67f0913075061e8102.jpg";